var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import Modal from 'components/Modal.vue';
import CompanyDrawerContactTabPhones from 'components/CompanyDrawerContactTabPhones.vue';
import CompanyDrawerContactTabEmails from 'components/CompanyDrawerContactTabEmails.vue';
import RelatedBusinessesButton from 'components/RelatedBusinesses/RelatedBusinessesButton.vue';
import { copyToClipboard } from 'quasar';
let CompanyDrawerContactTab = class CompanyDrawerContactTab extends Vue {
    constructor() {
        super(...arguments);
        this.clickCopy = false;
        this.failedCopyItem = false;
        this.tooltipStyle = `
    font-size:14px; background-color:#9EB3DC; min-width:180px; padding:.8rem;
  `;
    }
    get noContacts() {
        return this.allEmails.length === 0 && this.allPhones.length === 0;
    }
    get hasRelatedBusinesses() {
        return !!(this.company &&
            this.company.badges &&
            this.company.badges.hyperbolictree_size_estimation > 0);
    }
    get allEmails() {
        const emails = (this.company &&
            this.company.additionalContactData &&
            this.company.additionalContactData.emails) ||
            [];
        const validatedEmails = (this.company && this.company.emailValidatiosRealtime) || [];
        return emails.map(e => {
            const emailValidated = validatedEmails.find(ve => ve.email_address == e.email);
            const isDecisorEmail = e.flags.includes('decisor');
            const validation = isDecisorEmail
                ? 'valid'
                : (emailValidated && emailValidated.validation_status) || '';
            return {
                ...e,
                validation,
            };
        });
    }
    get allPhones() {
        const phones = this.company.additionalContactData.phones || [];
        const validatedPhones = this.company.phoneValidationRealtime || [];
        const whatsappValidations = this.company.whatsapp_validation || [];
        // 1. Criar um mapa de validações de telefone por número para busca rápida
        const validationMap = new Map(validatedPhones.map(vp => [vp.phone_number, vp.validation_status || '']));
        // 2. Criar um mapa de Whatsapps disponíveis (limpos) para evitar o uso de .splice
        // Guardamos o objeto original como valor
        const whatsappMap = new Map();
        whatsappValidations.forEach(wv => {
            if (wv && typeof wv.phone === 'string') {
                const cleaned = wv.phone.replace(/\D/g, '');
                if (cleaned)
                    whatsappMap.set(cleaned, wv);
            }
        });
        // Conjunto para rastrear quais números de whatsapp já foram "usados"
        const usedWhatsappCleaned = new Set();
        // 3. Processar telefones principais
        const consolidatedPhones = phones
            .map(p => {
            const phone = p.phone_formatted || p.phone || '';
            const cleanedPhone = phone.toString().replace(/\D/g, '');
            // Buscar validação no Map
            const validationStatus = validationMap.get(phone) || '';
            // Verificar se existe WhatsApp para este número limpo
            let whatsappStatus = '';
            if (whatsappMap.has(cleanedPhone)) {
                whatsappStatus = 'valid'; // ou o status vindo do objeto se necessário
                usedWhatsappCleaned.add(cleanedPhone); // Marca como usado
            }
            return {
                ...p,
                phone: phone,
                phone_formatted: phone,
                cleanedPhone: cleanedPhone,
                validation: validationStatus,
                whatsapp: whatsappStatus,
            };
        })
            .filter(p => p.cleanedPhone && p.cleanedPhone.length >= 10);
        // 4. Processar os Whatsapps que SOBRARAM (não foram vinculados a nenhum telefone principal)
        const leftoverWhatsappPhones = [];
        for (const [cleaned, wv] of whatsappMap.entries()) {
            if (!usedWhatsappCleaned.has(cleaned)) {
                const phone = wv.phone || '';
                leftoverWhatsappPhones.push({
                    phone: phone,
                    phone_formatted: phone,
                    cleanedPhone: cleaned,
                    flags: [],
                    origins: [],
                    validation: '',
                    whatsapp: 'valid',
                });
            }
        }
        // Filtrar os que sobraram por tamanho
        const filteredLeftovers = leftoverWhatsappPhones.filter(p => p.cleanedPhone.length >= 10);
        // 5. Unir as listas e ordenar (telefones que "nao existe" vão para o fim)
        return [...consolidatedPhones, ...filteredLeftovers].sort((a, b) => {
            if (a.validation === 'nao existe' && b.validation !== 'nao existe')
                return 1;
            if (a.validation !== 'nao existe' && b.validation === 'nao existe')
                return -1;
            return 0;
        });
    }
    get availableAddresses() {
        const contactDetails = this.company.additionalContactData;
        if (contactDetails && contactDetails.addresses) {
            return contactDetails.addresses;
        }
        else {
            return [];
        }
    }
    copyTextItem(item) {
        this.clickCopy = true;
        copyToClipboard(item)
            .then(r => {
            setTimeout(() => {
                this.clickCopy = false;
            }, 1000);
        })
            .catch(r => {
            setTimeout(() => {
                this.clickCopy = false;
                this.failedCopyItem = true;
            }, 1000);
        });
    }
    handleCopyIcon() {
        return this.clickCopy
            ? 'icon-copy-success'
            : this.failedCopyItem
                ? 'icon-copy-failed'
                : 'icon-copy';
    }
};
__decorate([
    Prop({ default: () => { } })
], CompanyDrawerContactTab.prototype, "company", void 0);
CompanyDrawerContactTab = __decorate([
    Component({
        name: 'CompanyDrawerContactTab',
        components: {
            Modal,
            CompanyDrawerContactTabPhones,
            CompanyDrawerContactTabEmails,
            RelatedBusinessesButton,
        },
    })
], CompanyDrawerContactTab);
export default CompanyDrawerContactTab;
